<template>

    <div class="layout__container">

        <div class="layout__width-90 layout__padding-clear">

        <span class="text__colour-teal layout__position-left layout__padding-10-4 layout__width-100 text__align-center">
            <h3 class="layout__position-center">Create Price Codes</h3><h4 class="layout__position-center">(Enter the record details and click to Save Changes or Cancel)</h4>
        </span>

            <el-form :model="price" ref="price" :rules="rules" class="layout__position-left layout__width-100">
                <div class="component__forms-3">
                    <el-form-item prop="code" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Code<span class="text__colour-red">*</span></div>
                        <el-input v-model="price.code" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>


                <div class="component__forms-3">
                    <el-form-item prop="type" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Type<span class="text__colour-red">*</span></div>
                        <el-select v-model="price.type" placeholder="Select Type" clearable="true">
                            <el-option
                                    v-for="type in ravensworth.priceCodeType.options"
                                    :key="type.id"
                                    :label="type.text"
                                    :value="type.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="component__forms-3">
                    <el-form-item prop="status" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Status<span class="text__colour-red">*</span>
                        </div>
                        <el-select v-model="price.status" placeholder="Select Status" clearable="true">
                            <el-option
                                    v-for="status in ravensworth.activeStatusWithHold.options"
                                    :key="status.id"
                                    :label="status.text"
                                    :value="status.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>


                <div class="layout__width-100">
                    <el-form-item prop="name" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Name<span class="text__colour-red">*</span></div>
                        <el-input v-model="price.name" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="layout__position-left layout__width-100 layout__margin-25-0">
                    <el-form-item prop="description" class="">
                        <p class="text_colour-909399 text__size-16">Description<span class="text__colour-red">*</span>
                        </p>
                        <el-input type="textarea" :rows="3" v-model="price.description"
                                  class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>

                <div class="component__forms-3">
                    <el-form-item prop="press" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Press<span class="text__colour-red">*</span></div>
                        <el-select v-model="price.press" placeholder="Select Press" clearable="true">
                            <el-option
                                    v-for="press in ravensworth.press.options"
                                    :key="press.id"
                                    :label="press.text"
                                    :value="press.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="paperWeight" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Paper Weight<span
                                class="text__colour-red">*</span></div>
                        <el-input autofocus v-model="price.paperWeight" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="sellPrice" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Default Sell Price<span
                                class="text__colour-red">*</span></div>
                        <el-input autofocus v-model="price.sellPrice" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>


                <div class="component__forms-3">

                    <el-form-item prop="style" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Style<span class="text__colour-red">*</span></div>
                        <el-input autofocus v-model="price.style" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="paperType" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Paper Type<span class="text__colour-red">*</span>
                        </div>
                        <el-input autofocus v-model="price.paperType" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="costPrice" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Cost Price<span class="text__colour-red">*</span>
                        </div>
                        <el-input autofocus v-model="price.costPrice" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="component__forms-3">
                    <el-form-item prop="isoSize" class="component__forms__fields">
                        <div class="component__forms__fields__labels">ISO Size<span class="text__colour-red">*</span>
                        </div>
                        <el-select v-model="price.isoSize" placeholder="Select ISO Size" clearable="true">
                            <el-option
                                    v-for="iso in ravensworth.isoSize.options"
                                    :key="iso.id"
                                    :label="iso.text"
                                    :value="iso.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="finishing" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Finishing<span class="text__colour-red">*</span>
                        </div>
                        <el-select v-model="price.finishing" placeholder="Select Finishing" clearable="true">
                            <el-option
                                    v-for="finishing in ravensworth.finishingType.options"
                                    :key="finishing.id"
                                    :label="finishing.text"
                                    :value="finishing.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="minQty" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Default Min Qty<span
                                class="text__colour-red">*</span></div>
                        <el-input v-model="price.minQty" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>


            </el-form>

            <div class="layout__padding-20px layout__padding-clear">
                <el-button class="button-red button__base__admin layout__position-right">Delete</el-button>
                <el-button class="button-teal button__base__admin layout__position-right layout__margin__right-20px"
                           v-on:click="cancelChanges()">Cancel Changes
                </el-button>
                <el-button class="button-red button__base__admin layout__position-right layout__margin__right-20px"
                           v-on:click="createPrice('price')">Save Changes
                </el-button>
                <div id="message"></div>
            </div>

        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "createCustomers",
        mixins: [axios, csvDownloadHelper, dataFormatter, backing],
        data() {
            const minQty = (rule, value, callback) => {
                if (this.price.minQty === 0 || this.price.minQty < 0) {
                    callback(new Error('Minimum Quantity required'));
                } else {
                    callback();
                }
            };
            return {
                price: {
                    code: '',
                    type: '',
                    status: 'ACTIVE',
                    name: '',
                    description: '',
                    press: '',
                    paperWeight: '',
                    sellPrice: '',
                    style: '',
                    paperType: '',
                    costPrice: '',
                    isoSize: '',
                    finishing: '',
                    minQty: 0,
                    stock: '',
                    coverDetails: "",
                    notes: "",
                    previousSellPrice: 0,
                    oldPrice: 0,
                    newPrice: 0,
                    id: ''
                },
                types: [],
                statuses: [],
                presses: [],
                isos: [],
                finishings: [],
                rules: {
                    code: [{
                        required: true,
                        message: 'price code required',
                        trigger: 'blur'
                    }],
                    type: [{
                        required: true,
                        message: 'type required',
                        trigger: 'blur'
                    }],
                    status: [{
                        required: true,
                        message: 'status required',
                        trigger: 'blur'
                    }],
                    name: [{
                        required: true,
                        message: 'name required',
                        trigger: 'blur'
                    }],
                    description: [{
                        required: true,
                        message: 'description required',
                        trigger: 'blur'
                    }],
                    press: [{
                        required: true,
                        message: 'press required',
                        trigger: 'blur'
                    }],
                    style: [{
                        required: true,
                        message: 'style required',
                        trigger: 'blur'
                    }],
                    isoSize: [{
                        required: true,
                        message: 'ISO Size required',
                        trigger: 'blur'
                    }],
                    paperWeight: [{
                        required: true,
                        message: 'paper weight required',
                        trigger: 'blur'
                    }],
                    paperType: [{
                        required: true,
                        message: 'paper type required',
                        trigger: 'blur'
                    }],
                    finishing: [{
                        required: true,
                        message: 'finishing required',
                        trigger: 'blur'
                    }],

                    costPrice: [{
                        required: true,
                        message: 'cost price required',
                        trigger: 'blur'
                    }],
                    sellPrice: [{
                        required: true,
                        message: 'default sell price required',
                        trigger: 'blur'
                    }],
                    minQty: [{
                        validator: minQty
                    }],
                }
            }
        },
        created() {
            this.isUserAuthorised();
        },
        methods: {
            createPrice(price) {
                this.$refs[price].validate((valid) => {
                    if (valid) {
                        console.log('done post')

                        const createPrices = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Pricing/Create`

                        console.log(this.price)

                        const loading = this.$loading({
                            lock: true,
                            text: 'Saving Changes...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });

                        Axios.post(createPrices, this.price, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response)
                                this.price = response.data.result
                                document.getElementById("message").innerText = "Price Code Successfully Created"
                                document.getElementById("message").classList.add('component__message-base', 'component__message-success', 'layout__display-block')
                                // this.priceCodes = response.data.value
                                loading.close()
                            })
                            .catch(error => {
                                document.getElementById("message").innerText = "There was a problem creating the price code - please try again"
                                document.getElementById("message").classList.add('component__message-base', 'component__message-fail', 'layout__display-block')
                                loading.close()
                            })

                    } else {
                        return false;
                    }
                })
            },
            cancelChanges() {
                this.price =
                    {
                        code: '',
                        type: '',
                        status: '',
                        name: '',
                        description: '',
                        press: '',
                        paperWeight: '',
                        sellPrice: '',
                        style: '',
                        paperType: '',
                        costPrice: '',
                        isoSize: '',
                        finishing: '',
                        minQty: 0,
                        stock: '',
                        coverDetails: "",
                        notes: "",
                        previousSellPrice: 0,
                        oldPrice: 0,
                        newPrice: 0,
                        id: ''
                    }
            }
        }
    };
</script>